import { Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Page
import { MasterPage } from '../../pages/master/master';
import { LoginPage } from '../../pages/login/login';
import { SideMenuPage } from '../../pages/side-menu/side-menu';
import { BreadcrumbsPage } from '../../pages/breadcrumbs/breadcrumbs';
// import { PublicShareComponent } from '../../components/public-share/public-share';
// import {DrivePage} from '../../pages/drive/drive';
import { FileUploadPage } from '../../pages/file-upload/file-upload';
import { MyGridApplicationComponent } from "../../components/my-grid-application/my-grid-application";

// form
import { MailCampaignComponent } from '../../components/form/mail-campaign/mail-campaign';
import { defaultForm } from '../../components/form/defaultForm/defaultForm.component';
import { FormGridComponent } from '../../components/form-grid/form-grid';
import { PrivateShareComponent } from '../../components/private-share/private-share';
//holder
import { ComponentHolderComponent } from '../../components/component-holder/component-holder';
//Libraries
 import { ComponentLibService } from 'drive-uilib';
 import{EpcuiService} from 'epcui';
//  import { ComponentLibService} from '../../../node_modules/driveui-lib'
let customComponents = ComponentLibService.getCustomFormComponents();
let dynmaicComponents = EpcuiService.getCustomFormComponents();
let formComponents: any = [
  { 'compName': 'Form', 'comp': defaultForm },
  { 'compName': 'FormGridComponent', 'comp': FormGridComponent },
  { 'compName': 'SEARCHGRID', 'comp': FormGridComponent },
  { 'compName': 'SUMMARY', 'comp': FormGridComponent },
  { 'compName': 'MasterPage', 'comp': MasterPage },
  { 'compName': 'LoginPage', 'comp': LoginPage },
  { 'compName': 'SideMenuPage', 'comp': SideMenuPage },
  { 'compName': 'BreadcrumbsPage', 'comp': BreadcrumbsPage },
  { 'compName': 'FileUploadPage', 'comp': FileUploadPage },
  { 'compName': 'MailCampaignComponent', 'comp': MailCampaignComponent },
  { 'compName': 'FileUploadPage', 'comp': FileUploadPage },
  { 'compName': 'PublicShareComponent', 'comp': PrivateShareComponent },
  { 'compName': 'PrivateShareComponent', 'comp': PrivateShareComponent },

  // Default Form Custom Templates
  { 'compName': 'Mail_Campaign516-customForm', 'comp': MailCampaignComponent },
  // holder templates
  { 'compName': 'default-Holder', 'comp': ComponentHolderComponent },
];

/* *
* code for libaray components
* * */
console.log("customComponents", customComponents);
for (let i = 0; i < customComponents.length; i++) {
  formComponents.push(customComponents[i]);
}
for (let i = 0; i < dynmaicComponents.length; i++) {
  formComponents.push(dynmaicComponents[i]);
}
console.log("formComponents", formComponents);

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule
  ]
})

@Injectable()
export class componentHolderService {
  constructor() { }

  getComponents() {
    return formComponents;;
  }

  getComponent(name) {
    let components = formComponents;
    for (let i = 0; i < components.length; i++) {
      let item = components[i];
      if (item.compName === name) {
        console.log(item.compName);
        return item['comp'];
      }
    };
    return null;
  }
}




// WEBPACK FOOTER //
// ./src/providers/component-holder.service/component-holder.service.ts